import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
     navInfo:{}
  },
   //调用方法
   mutations: {
    setNavInfo(state, val) {
        if (val) {
          state.navInfo=val;
        }
      
    }
  }
})
